import React, { useEffect, useRef, useState, Fragment } from 'react';
import { Button } from '@nerdwallet/currency';

import classes from '@nerdwallet/base-styles/classes';
import { trackImpression } from '../../lib/analytics-helpers';
import { openAuthDialog } from '../../lib/helpers';

const HomePageReg = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const screenRef = useRef();

  const trkLocation = 'hp_reg';
  const dashboardUrl = '/home/dashboard/home';

  const openRegisterAuthDialogHelper = () => {
    openAuthDialog('register', trkLocation);
  };

  useEffect(() => {
    const isLoggedIn =
      // eslint-disable-next-line no-underscore-dangle
      window?.__GLOBAL_MARKUP_INITIAL_STATE__?.isLoggedIn;

    const authEmbedProps = {
      el: screenRef.current,
      authType: 'register',
      flowConfig: {
        isWelcomeRegModal: true,
        enableSuccessErrorModals: false,
        isHomePageReg: true,
        openRegisterAuthDialog: openRegisterAuthDialogHelper,
      },
      version: 2,
      flow: 'no-security-question',
      trk: {
        trk_location: trkLocation,
      },
      onSuccess() {
        trackImpression('hp_reg_success');
        setIsUserLoggedIn(isLoggedIn);
      },
      onFailure() {
        trackImpression('hp_reg_failure');
      },
    };

    if (!isLoggedIn) {
      authEmbedProps.onSuccess = dashboardUrl;
    }

    window.nwapi?.ui?.showAuthEmbed(authEmbedProps);
  }, []);

  return (
    <Fragment>
      <div ref={screenRef} />
      {isUserLoggedIn ? (
        <div className={classes('margin-vertical-3')}>
          <Button secondary block href={dashboardUrl}>
            Go to My NerdWallet
          </Button>
        </div>
      ) : null}
    </Fragment>
  );
};

export default HomePageReg;
